export const CREATE_SALES_RETURN = 'CREATE_SALES_RETURN';
export const GET_SALES_RETURNS = 'GET_SALES_RETURNS';
export const GET_SALES_RETURNS_PAGE = 'GET_SALES_RETURNS_PAGE';
export const SALES_RETURN_REQUEST = 'SALES_RETURN_REQUEST';
export const UPDATE_SALES_RETURN = 'UPDATE_SALES_RETURN';
export const DELETE_SALES_RETURN = 'DELETE_SALES_RETURN';
export const SALES_RETURN_REQUEST_SUCCESS = 'SALES_RETURN_REQUEST_SUCCESS';
export const SALES_RETURN_REQUEST_FAILURE = 'SALES_RETURN_REQUEST_FAILURE';
export const SET_BILL_ORDERS = 'SET_BILL_ORDERS';